import React from 'react';

function Footer() {
  return (
    <React.Fragment>
      <div className='footer'>
        <p>
          Made with <span className='heart'>♥</span> by Asclepeion
        </p>
      </div>
    </React.Fragment>
  );
}

export default Footer;
